import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { en } from "./en";
import { pl } from "./pl";
import { de } from "./de";
import { fr } from "./fr";
import { it } from "./it";
import { hr } from "./hr";

export const DICTS = { en, pl, de, fr, it, hr };

export const LANGS = [
  { code: "en", label: "English" },
  { code: "pl", label: "Polski" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "it", label: "Italiano" },
  { code: "hr", label: "Hrvatski" },
];

const LangContext = createContext({ lang: "en", setLang: () => {}, t: en });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" && window.localStorage.getItem("hadron-lang");
    if (saved && DICTS[saved]) return saved;
    const nav = typeof navigator !== "undefined" ? navigator.language || "" : "";
    return nav.toLowerCase().startsWith("pl") ? "pl" : "en";
  });

  const t = DICTS[lang];

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = t.meta.title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", t.meta.description);
  }, [lang, t]);

  const setLang = (code) => {
    if (!DICTS[code]) return;
    setLangState(code);
    window.localStorage.setItem("hadron-lang", code);
  };

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
